import { render, staticRenderFns } from "./MV.vue?vue&type=template&id=665d9fee"
import script from "./MV.vue?vue&type=script&lang=js"
export * from "./MV.vue?vue&type=script&lang=js"
import style0 from "./MV.vue?vue&type=style&index=0&id=665d9fee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports